export function Button({ variant = 'primary', size = 'md', icon: Icon, children, className = '', ...props }) {
  return (
    <button
      className={`btn btn-${variant} ${size === 'sm' ? 'btn-sm' : ''} ${className}`}
      {...props}
    >
      {Icon && <Icon size={size === 'sm' ? 14 : 16} strokeWidth={2.2} />}
      {children}
    </button>
  );
}

export function IconButton({ icon: Icon, title, onClick, variant = 'ghost' }) {
  return (
    <button
      title={title}
      onClick={onClick}
      className={`btn btn-${variant} btn-sm btn-icon`}
    >
      <Icon size={14} strokeWidth={2.2} />
    </button>
  );
}
